import React from "react";
import htmlParse from "html-react-parser";
import Button from "../../../Foundation/Button/Button";
import { _LandingHighlighProductRoot } from "./LandingHighlighProduct.styled";
import HighlightedTypography from "../../HighlightedTypography/HighlightedTypography";
import Typography from "../../../Foundation/Typography/Typography";
import LandingSectionBase, {
  ILandingSectionBaseProps,
} from "../LandingSectionBase/LandingSectionBase";
import FlexBox from "../../FlexBox/FlexBox";
import CompositionItem from "./CompositionItem/CompositionItem";
import LandingPriceList from "../LandingInnovation/InnovationProduct/LandingPriceList/LandingPriceList";

export interface IProductComposition {
  id_product: string;
  quantity: number;
  title: string;
  imageId: string;
  subtitle?: string;
  description?: string;
  highlighted?: boolean;
}

export type ICompositionVariant =
  | {
      type: "box";
      list: IProductComposition[];
    }
  | {
      type: "paragraph";
      text: string;
    };
export interface ILandingHighlighProductProps {
  image?: string;
  video?: string;
  animation?: ILandingSectionBaseProps["animation"];
  title: string;
  highlitedTitle?: string;
  description?: string;
  ctaLabel: string;
  hideCta?: boolean;
  onClick?: () => void;
  backgroundImage?: {
    desktop?: string;
    mobile?: string;
  };
  imageLeft?: boolean;
  compositions?: ICompositionVariant;
  compositionLabel: string;
  price?: string;
  priceSubtitle?: string;
  product_display_from_mention?: string;
  product_price_vae?: string;
  product_price_vad?: string;
  vaeLabel?: string;
  vadLabel?: string;
  variant?: "top-center-title" | "composition-title";
  renderMiddleMedia?: ILandingSectionBaseProps["renderImage"];
  backgroundBehindContainer?: ILandingSectionBaseProps["backgroundBehindContainer"];
}

const LandingHighlighProduct = (props: ILandingHighlighProductProps) => {
  const {
    image,
    video,
    animation,
    title,
    highlitedTitle,
    description,
    ctaLabel = "Je découvre",
    hideCta = false,
    onClick,
    backgroundImage,
    imageLeft = false,
    compositionLabel,
    compositions,
    price,
    priceSubtitle,
    product_display_from_mention,
    product_price_vae,
    product_price_vad,
    variant = "composition-title",
    vaeLabel,
    vadLabel,
    renderMiddleMedia,
    backgroundBehindContainer,
  } = props;
  const isTopTitle = variant === "top-center-title";
  const topContent = (
    <FlexBox direction="column" gap={12} className="top-container">
      <HighlightedTypography highlightedText={highlitedTitle} variant="h4">
        {title}
      </HighlightedTypography>
      {description && (
        <Typography variant="subtitle2">
          {htmlParse(description + "")}
        </Typography>
      )}
    </FlexBox>
  );
  return (
    <_LandingHighlighProductRoot>
      <LandingSectionBase
        boxContainer={true}
        topVariant="align-left"
        topPosition={(isTopTitle && "top") || undefined}
        topContentSize={!title ? "small" : "default"}
        backgroundImage={backgroundImage}
        backgroundBehindContainer={backgroundBehindContainer}
        image={image}
        video={video}
        animation={animation}
        renderImage={renderMiddleMedia}
        imageLeft={imageLeft}
        topContent={topContent}
        onImageClick={onClick}
        bottomContent={
          <FlexBox direction="column" gap={26}>
            <FlexBox mt={32} direction="column" gap={17}>
              <Typography variant="ui">{compositionLabel}</Typography>
              {!compositions ? null : compositions.type === "box" ? (
                <FlexBox direction="column" gap={4}>
                  {compositions.list.map((item) => {
                    return (
                      <CompositionItem key={item.id_product} product={item} />
                    );
                  })}
                </FlexBox>
              ) : compositions.type === "paragraph" ? (
                <Typography>{compositions.text}</Typography>
              ) : null}
            </FlexBox>

            {/* price */}
            <LandingPriceList
              price={price}
              product_price_vae={product_price_vae}
              product_price_vad={product_price_vad}
              product_display_from_mention={product_display_from_mention}
              priceSubtitle={priceSubtitle}
              vaeLabel={vaeLabel}
              vadLabel={vadLabel}
            />

            {!hideCta && (
              <div>
                <Button
                  variant="champagne"
                  className="landing-action-button"
                  onClick={onClick}
                >
                  {ctaLabel}
                </Button>
              </div>
            )}
          </FlexBox>
        }
      />
    </_LandingHighlighProductRoot>
  );
};

export default LandingHighlighProduct;
